export class ClassHelper {
  public static periodIndex(index = 0) {
    return `period-index-${index}`;
  }

  public static requestedResource() {
    return 'RequestedResource'; // Coming from AssignmentRowType.RequestedResource..
  }

  public static resourceCode(code?: string) {
    return code ? `r-${code}` : '';
  }

  public static projectCode(code?: string) {
    return code ? `p-${code}` : '';
  }

  public static portalLevel(level = 0) {
    return `portal-level-${level}`;
  }
}
